var Handlebars = require("/root/project/webapp/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var alias1=container.escapeExpression;

  return "<form class=\"form-horizontal\" role=\"form\">\n    <div class=\"form-group name\">\n        <label class=\"col-sm-3 control-label\" for=\"name\">\n            "
    + alias1(__default(require("/root/project/webapp/src/common/ui/template/helper/i18n.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"balus_template_body_group:nav.project-content.name",{"name":"i18n","hash":{},"data":data}))
    + "\n        </label>\n        <div class=\"col-sm-9\">\n            <input type=\"text\" name=\"name\" class=\"form-control name\"\n                   placeholder=\"Name\" value=\""
    + alias1(container.lambda((depth0 != null ? depth0.name : depth0), depth0))
    + "\" />\n            <span class=\"alert-message text-danger\"></span>\n        </div>\n    </div>\n</form>";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./balus/ui/template/body/group/nav/project-create.hbs
// module id = 972
// module chunks = 0